import { render, staticRenderFns } from "./GBarChart.vue?vue&type=template&id=509301b8&"
import script from "./GBarChart.vue?vue&type=script&lang=js&"
export * from "./GBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports